/* eslint-disable */
import swal from 'sweetalert2'

const getSettings = async (store) => {
  // store.dispatch('getSettings')
}

export async function trafficSystem(path, router, store) {
  getSettings(store);

		// const alert = alerts.find((alert) => alert.path === path)
		// if (alert) {
    //   swal({
    //     title: alert.title,
    //     text: alert.message,
    //     type: 'warning',
    //     showCancelButton: false,
    //     confirmButtonClass: 'btn btn-info btn-fill',
    //     confirmButtonText: 'OK',
    //     buttonsStyling: false,
    //     allowOutsideClick: false,
    //     preConfirm: () => {
    //       return (new Promise((resolve, reject) => {
    //         resolve('OK')
    //       }))
    //     }
    //   }).then(() => {
    //     if (alert.redirect) {
    //       router.push(alert.redirect)
    //     }
    //   }).catch(swal.noop)
  	// }
}


// WEBPACK FOOTER //
// ./src/services/trafficSystem.js